import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, X } from "lucide-react";
import SubscribeForm from "@/components/blog/SubscribeForm";

/**
 * Slim strip that sits above the main navigation on the homepage.
 * Invites visitors to read and follow the journal.
 */
export const FollowBanner = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      data-testid="follow-banner"
      className="bg-[#0A0A0A] text-white h-10 flex items-center"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 w-full flex items-center justify-between gap-4 text-xs">
        <Link
          to="/blog"
          data-testid="banner-journal-link"
          className="flex items-center gap-3 min-w-0 group"
        >
          <span className="w-1.5 h-1.5 bg-emerald-400 rounded-full live-dot shrink-0" />
          <span className="tracking-[0.18em] uppercase font-bold text-white/60 group-hover:text-white transition-colors shrink-0">
            Journal
          </span>
          <span className="hidden sm:inline text-white/80 group-hover:text-white transition-colors truncate">
            Notes on fit-out, workshop craft and AI in the engine room.
          </span>
        </Link>

        <div className="flex items-center gap-5 shrink-0">
          {expanded ? (
            <div className="flex items-center gap-3 w-[280px] sm:w-[340px]">
              <SubscribeForm source="banner" tone="dark" compact testid="banner-subscribe" />
              <button
                onClick={() => setExpanded(false)}
                aria-label="Close"
                data-testid="banner-subscribe-close"
                className="text-white/50 hover:text-white transition-colors"
              >
                <X size={14} />
              </button>
            </div>
          ) : (
            <>
              <Link
                to="/blog"
                data-testid="banner-read-link"
                className="inline-flex items-center gap-1.5 text-white/80 hover:text-white transition-colors"
              >
                Read the latest <ArrowRight size={12} />
              </Link>
              <button
                onClick={() => setExpanded(true)}
                data-testid="banner-follow-button"
                className="hidden sm:inline-flex items-center px-3 py-1 border border-white/30 hover:bg-white hover:text-[#0A0A0A] transition-colors tracking-wide"
              >
                Follow by email
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default FollowBanner;
